// extracted by mini-css-extract-plugin
export default {"uppercase":"uppercase__OGjTa","hidden":"hidden__S8ayK","chartsErrorComponent":"chartsErrorComponent__EBkTh","chartDescription":"chartDescription__qJGow"};